import dynamic from 'next/dynamic'

import { styled, Text, spacing } from '@thg-commerce/gravity-theme'

const LoyaltyIcon = dynamic(
  () => import('@thg-commerce/gravity-icons/src/components/LoyaltyIcon'),
  { ssr: true, loading: () => <div style={{ height: 24, width: 24 }} /> },
)

export const Container = styled.div`
  display: flex;
  align-items: center;
`

export const LoyaltyText = styled.span`
  ${Text('bodyText', 'alternate')};
`

export const StyledIcon = styled(LoyaltyIcon)`
  margin-right: ${spacing(1)};
`
